

import './pipeline-summary.scss';

/* @ngInject */
export default class PipelineSummaryController {
    constructor($scope, UserData, PipelineSummaryService) {
        this.PipelineSummaryService = PipelineSummaryService;

        this.summaries = {};
        this.loading = false;
        this.errorState = false;


        UserData.getCurrentLocation().then((newLocation) => {
            this.getSummary(newLocation.ContractorId);
        });

        $scope.$on('HPLocationChange', (event, newLocation) => {
            this.getSummary(newLocation.ContractorId);
        });
    }

    getSummary(contractorId) {
        this.loading = true;
        this.PipelineSummaryService.getSummary(contractorId).then((response) => {
            if (response.data.ResultCode !== 1) {
                this.summaries = response.data.Data;
                this.errorState = false;
            } else {
                this.errorState = true;
            }
            this.loading = false;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/pipelineSummary/pipelineSummary.controller.js